const commentifyTypes = {
	NEWEST_COMMENTS: {
		REQUEST: 'NEWEST_COMMENTS_REQUEST',
		SUCCESS: 'NEWEST_COMMENTS_SUCCESS',
		FAILURE: 'NEWEST_COMMENTS_FAILURE',
		CLEAR: 'NEWEST_COMMENTS_CLEAR',
	},
	REPLY: {
		REQUEST: 'COMMENTIFY_REPLY_REQUEST',
		SUCCESS: 'COMMENTIFY_REPLY_SUCCESS',
		FAILURE: 'COMMENTIFY_REPLY_FAILURE',
		CLEAR: 'COMMENTIFY_REPLY_CLEAR',
	},
};

export default commentifyTypes;
